import { useEffect } from "react";

export default function Modal({ open, title, children, onClose }) {
  useEffect(() => {
    if (!open) return;

    const onKeyDown = (e) => {
      if (e.key === "Escape") onClose?.();
    };

    document.addEventListener("keydown", onKeyDown);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.removeEventListener("keydown", onKeyDown);
      document.body.style.overflow = prevOverflow;
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      {/* Overlay */}
      <div
        className="absolute inset-0 bg-black/70 backdrop-blur-[2px]"
        onClick={onClose}
      />

      {/* Panel */}
      <div
        className="
          relative w-full max-w-md
          rounded-2xl
          border border-border-soft
          bg-bg-panel
          shadow-2xl
          overflow-hidden
          animate-[modalIn_140ms_ease-out]
        "
      >
        {/* Header */}
        <div className="flex items-center justify-between px-5 py-4 border-b border-border-soft bg-bg-panel2/40">
          <div className="font-semibold text-gray-100">{title}</div>

          <button
            className="
              h-9 w-9 inline-flex items-center justify-center
              rounded-xl
              border border-border-soft
              bg-bg-panel2
              text-text-soft
              hover:text-gray-100
              hover:bg-bg-panel2/80
              transition-colors
            "
            onClick={onClose}
            aria-label="Close modal"
            title="Close"
          >
            ✕
          </button>
        </div>

        {/* Body */}
        <div className="p-5 text-gray-200">{children}</div>
      </div>

      {/* Keyframes (Tailwind arbitrary animation needs this in global CSS in some setups)
          If your build doesn't allow animate-[...], remove the animate class above. */}
      <style>{`
        @keyframes modalIn {
          from { transform: translateY(6px) scale(0.99); opacity: 0; }
          to   { transform: translateY(0)   scale(1);    opacity: 1; }
        }
      `}</style>
    </div>
  );
}
